import { combineReducers } from 'redux';

import * as actionTypes from '@store/checkboxFilter/action-types';

const getSelectedItems = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_CHECKBOX_FILTER_REQUEST:
		case actionTypes.FETCH_CHECKBOX_FILTER_FAILURE:
			return state;
		case actionTypes.FETCH_CHECKBOX_FILTER_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const checkboxFilterReducer = combineReducers({
	allSelectedItems: getSelectedItems
});

export default checkboxFilterReducer;
